<div  tuiDropdownHover tuiDropdownAlign="right" [tuiDropdown]="emojiListTmp" [(tuiDropdownOpen)]="emojiListOpened">
  <button
    tuiIconButton
    #tuiDropdownHost
    type="button"
    iconStart="@tui.smile"
    [appearance]="'icon'"
    [size]="'s'"
  ></button>
</div>

<ng-template #emojiListTmp>
  <app-emoji-list (emojiClicked)="emojiClicked.emit($event)"></app-emoji-list>
</ng-template>
